<!-- Formaulario Vertical - Suporte -->
<div class="row mx-0 w-100 pt-3" *ngFor="let sign of supportTaskActivities; index as indexOfSupport">
  <div class="col d-flex sign-container mb-4 w-100">
    <div class="col-1 pt-2 d-flex justify-content-center">
      <img [src]="sign?.contractVerticalItem?.supportMaterial ? ( sign.contractVerticalItem.supportMaterial |
            enumSvg:'Signaling') : 'assets/icons/v-support-task-icon.svg'" alt="" height="48px" width="48px">
    </div>
    <div class="col mt-2 ">
      <div class="content-contractual">
        <form #supportForm="ngForm">
          <div class="my-3" *ngIf="stockEntries?.length && !isStock">
            <div class="row mx-0 d-flex align-items-center justify-content-between">
              <div class="col custom-control custom-radio mb-2">
                <input type="radio" name="supportStockOrContractRadio{{indexOfSupport + 1}}"
                  id="supportStockOrContractRadio{{indexOfSupport + 1}}1" class="custom-control-input cursor-pointer"
                  (change)="setBond('contract',indexOfSupport)" [checked]="radioState[indexOfSupport]?.contract">
                <label class="custom-control-label pl-2" style="font-size: 16px;"
                  for="supportStockOrContractRadio{{indexOfSupport + 1}}1">Item do
                  Contrato</label>
              </div>
              <div class="col custom-control custom-radio mb-2">
                <input type="radio" name="supportStockOrContractRadio{{indexOfSupport + 1}}"
                  id="supportStockOrContractRadio{{indexOfSupport + 1}}2" class="custom-control-input cursor-pointer"
                  (change)="setBond('stock', indexOfSupport)" [checked]="radioState[indexOfSupport]?.stock">
                <label class="custom-control-label pl-2" style="font-size: 16px;"
                  for="supportStockOrContractRadio{{indexOfSupport + 1}}2">Vínculo
                  com Estoque</label>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="form-group col-3 pl-0 d-flex">
              <div class="form-group" *ngIf="sign?.id">
                <label for="quantity">Qtd. Usada</label>
                <spam>{{sign?.quantityRegistered}}</spam>
              </div>

              <div>
                <label for="quantity">Quantidade</label>
                <input name="quantity" class="form-control" required placeholder="0" type="number"
                  [(ngModel)]="sign.quantityToBeRegistered"
                  (change)="verifyQuantity(indexOfSupport);emitValidation(sign);setCost(sign);" min="0"
                  oninput="if(this.value < 0) this.value = 0;">
              </div>
            </div>
            <div class="form-group w-100 snow-light-container" *ngIf="!radioState[indexOfSupport]?.stock">
              <label for="contractVerticalItemId">Selecione o item do Contrato</label>
              <select name="contractVerticalItemId" required class="form-control"
                placeholder="Selecione o item do contrato"
                (change)="sign.contractVerticalItemId = $event.target.value;setContractItem(sign); emitValidation(sign)"
                [(ngModel)]="sign.contractVerticalItemId">
                <option value="" hidden>Selecione...</option>
                <option *ngFor="let option of supportItems" [value]="option.id">{{option?.name}}
                </option>
              </select>
            </div>
            <div class="form-group w-100" *ngIf="radioState[indexOfSupport]?.stock">
              <label for="stockedTrafficSignId">Selecione o item do Estoque</label>
              <select name="stockedTrafficSignId" class="form-control" [(ngModel)]="sign.stockedSupportId" required
                (change)="setContractItem(sign, $event.target.value, indexOfSupport); emitValidation(sign)">
                <option [value]="undefined" hidden>Selecione...</option>
                <option *ngFor="let item of stockEntries" [value]="item.id">
                  {{item.contractVerticalItem.name+ ' - '+(item.quantity - item.quantityRegistered)+'
                  disponíveis'}}
                </option>
              </select>
            </div>
          </div>
        </form>
        <ng-container *ngIf="task?.onlySupport">
          <div class="snow-light-container mb-3 d-flex col-10" style="justify-self: flex-end;">
            <div class="d-flex align-items-center justify-content-between w-100 mb-2">
              <div class="d-flex align-items-center w-100 ml-3" style="gap: 32px">
                <img [src]="
                        sign.verticalCode
                          ? (sign.verticalCode | enumSvg: 'Signaling':typeSignEnum.Vertical)
                          : 'assets/icons/v-sign-task-icon.svg'
                      " alt="" height="48px" width="48px" style="object-fit: contain;"
                  [ngClass]="{'sign-cam-40': sign?.verticalCode == verticalSignEnum.ViaFiscalizadaPorCameras}" />

                <span style="color: var(--gray-base)">
                  {{
                  sign.verticalCode
                  ? (sign.verticalCode | enumText: 'Signaling')
                  : 'Selecione a sinalização complementar.'
                  }}
                </span>
              </div>

              <button class="btn-popup button-sign p-0" *ngIf="!radioState[indexOfSign]?.stock">
                <div class="d-flex align-items-center justify-content-center flex-column"
                  style="width: 123px; height: 46px"
                  (click)="currentItem = sign; currentIndex = indexOfSign; openModalXL(selectSign)">
                  <p class="m-0">SELECIONAR</p>
                </div>
              </button>
            </div>
          </div>
        </ng-container>

        <div class="row  px-4 justify-content-between align-items-center  my-2 py-2">
          <div class="col px-0">
            <div>
              <label for="signQuant" class="text-muted">Qnt. de Sinalizações</label>
              <p>{{sign?.quantity || 0}}</p>
            </div>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Tipo de Suporte</label>
            <p>{{sign.contractVerticalItem.supportMaterial ? (sign.contractVerticalItem.supportMaterial |
              enumText:'RoadSignSupport') : 'Não informado'}}</p>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Vr. Unt. da Sinalização</label>
            <p class="text-success">{{sign.contractVerticalItem ? (sign.quantity *
              sign.contractVerticalItem.unitValue | currency:'BRL':'R$') : ('R$ 0,00')}}</p>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Valor do Item</label>
            <p>{{ sign.contractVerticalItem ? ((sign.contractVerticalItem.unitValue |
              currency:'BRL':'R$')+'/'+(sign.contractVerticalItem.unit)) : ('R$ 0,00/--')}}</p>
          </div>
          <div class="col px-0">
            <label for="signQuant" class="text-muted">Valor Total</label>
            <p class="text-success">{{sign.contractVerticalItem ? (sign.quantity *
              sign.contractVerticalItem.unitValue | currency:'BRL':'R$') : ('R$ 0,00')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-auto px-0 pl-4" *ngIf="!isStock">
    <button class="btn btn-icon btn-icon-alt" (click)="removeActivity(indexOfSupport)">
      <i class="fa-regular fa-xmark fa-lg text-danger"></i>
    </button>
  </div>
</div>

<!-- Template Modal Selecionar Sinalização Filtro-->
<ng-template #selectSign>
  <app-sign-list-modal [signType]="typeSignEnum.Vertical" [signModalSelect]="currentItem.verticalCode"
    (shareSelectSign)="selectSignModal($event);" (shareCloseModal)="closeModal()">
  </app-sign-list-modal>
</ng-template>
<!-- Template Modal Selecionar Sinalização Filtro-->
